import React, { useState } from 'react';
import { C, S } from '../../utils/styles';
import Icon from '../Icon';

export default function HelpSection({ title, sections }) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div style={{ 
      marginBottom: 20,
      border: `1px solid ${C.blue}`,
      borderRadius: 8,
      background: C.blueLight,
      overflow: 'hidden'
    }}>
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          width: '100%',
          padding: '12px 16px',
          background: 'transparent',
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
          fontFamily: "'Inter', sans-serif"
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Icon name="help-circle-outline" style={{ fontSize: 20, color: C.blue }} />
          <span style={{ fontSize: 13, fontWeight: 600, color: C.blue }}>
            {title || 'How does this work?'}
          </span>
        </div>
        <Icon 
          name={isExpanded ? 'chevron-up-outline' : 'chevron-down-outline'} 
          style={{ fontSize: 18, color: C.blue }} 
        />
      </button>

      {isExpanded && (
        <div style={{ 
          padding: '0 16px 16px',
          fontSize: 12,
          lineHeight: 1.7,
          color: C.text
        }}>
          {sections.map((section, idx) => (
            <div key={idx} style={{ marginBottom: idx < sections.length - 1 ? 16 : 0 }}>
              <h4 style={{ 
                fontSize: 13, 
                fontWeight: 700, 
                marginBottom: 6,
                color: C.text
              }}>
                {section.heading}
              </h4>
              <div style={{ color: C.textMid }}>
                {typeof section.content === 'string' ? (
                  <p style={{ margin: 0 }}>{section.content}</p>
                ) : (
                  section.content
                )}
              </div>
              {section.impacts && (
                <div style={{ 
                  marginTop: 8,
                  padding: 10,
                  background: 'white',
                  borderRadius: 6,
                  border: `1px solid ${C.borderLight}`
                }}>
                  <div style={{ fontSize: 11, fontWeight: 700, marginBottom: 4, color: C.accent }}>
                    💡 Impacts:
                  </div>
                  <ul style={{ margin: 0, paddingLeft: 20, fontSize: 11 }}>
                    {section.impacts.map((impact, i) => (
                      <li key={i} style={{ marginBottom: 2 }}>{impact}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
